"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _miniProgramVersionApi = require("@/api/miniProgramVersionApi");
var _companyappApi = require("@/api/companyappApi");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ENVIRONMENTS = [{
  code: 'LOCALTEST',
  name: 'LOCALTEST',
  domain: 'https://localtest.api.fucaiyijia.com'
}, {
  code: 'VIR',
  name: 'VIR',
  domain: 'https://vir.apif.fucaiyijia.com'
}, {
  code: 'PRE',
  name: 'PRE',
  domain: 'https://pre.api.fucaiyijia.com'
}, {
  code: 'PROD',
  name: 'PROD',
  domain: 'https://apif.fucaiyijia.com'
}, {
  code: 'CUSTOM',
  name: '自定义',
  domain: ''
}];
var _default = exports.default = {
  name: 'BatchUploadDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      submitting: false,
      environments: ENVIRONMENTS,
      appRows: [],
      selectedRows: [],
      form: this.getDefaultForm(),
      rules: {
        versionDesc: [{
          required: true,
          message: '请输入版本描述',
          trigger: 'blur'
        }],
        environmentCode: [{
          required: true,
          message: '请选择接口环境',
          trigger: 'change'
        }],
        customDomain: [{
          required: true,
          message: '请输入统一自定义域名',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    getDefaultForm: function getDefaultForm() {
      return {
        versionDesc: '',
        environmentCode: 'VIR',
        customDomain: '',
        trialRequested: false
      };
    },
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.visible = true;
              this.form = this.getDefaultForm();
              this.selectedRows = [];
              _context.n = 1;
              return this.loadApps();
            case 1:
              this.$nextTick(function () {
                if (_this.$refs.appTable) _this.$refs.appTable.clearSelection();
                if (_this.$refs.batchForm) _this.$refs.batchForm.clearValidate();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    loadApps: function () {
      var _loadApps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var data, appRows;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _miniProgramVersionApi.getMiniProgramAppList)({
                page: 1,
                limit: 1000
              });
            case 2:
              data = _context3.v;
              appRows = data.list || [];
              _context3.n = 3;
              return Promise.all(appRows.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
                  var prepare, wechatApiReady, suggestedVersion, _t;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        prepare = null;
                        _context2.p = 1;
                        _context2.n = 2;
                        return (0, _companyappApi.getMiniProgramPrepareApi)(item.id);
                      case 2:
                        prepare = _context2.v;
                        _context2.n = 4;
                        break;
                      case 3:
                        _context2.p = 3;
                        _t = _context2.v;
                      case 4:
                        wechatApiReady = Boolean(prepare && prepare.wechatApiReady);
                        suggestedVersion = prepare && (prepare.suggestedVersion || prepare.onlineVersion);
                        return _context2.a(2, _objectSpread(_objectSpread({}, item), {}, {
                          branchName: item.branchName || '',
                          uniAppId: item.uniAppId || '',
                          environmentCode: _this2.form.environmentCode,
                          robotNo: _this2.getRobotNoByEnvironment(_this2.form.environmentCode),
                          customDomain: '',
                          onlineVersion: prepare && prepare.onlineVersion || '',
                          versionNo: wechatApiReady ? suggestedVersion || '' : '',
                          versionNoReadonly: wechatApiReady && Boolean(suggestedVersion),
                          wechatApiReady: wechatApiReady,
                          trialRequested: _this2.form.trialRequested
                        }));
                    }
                  }, _callee2, null, [[1, 3]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 3:
              this.appRows = _context3.v;
            case 4:
              _context3.p = 4;
              this.loading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 4, 5]]);
      }));
      function loadApps() {
        return _loadApps.apply(this, arguments);
      }
      return loadApps;
    }(),
    handleSelectionChange: function handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    getTargetDomain: function getTargetDomain(code) {
      var environment = ENVIRONMENTS.find(function (item) {
        return item.code === code;
      });
      return environment ? environment.domain : '';
    },
    getRobotNoByEnvironment: function getRobotNoByEnvironment(code) {
      var currentRobotNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      var fixedRobotNos = {
        PROD: 1,
        PRE: 2,
        VIR: 3,
        LOCALTEST: 4
      };
      if (fixedRobotNos[code]) return fixedRobotNos[code];
      return currentRobotNo >= 5 && currentRobotNo <= 30 ? currentRobotNo : 5;
    },
    handleRowEnvironmentChange: function handleRowEnvironmentChange(row, code) {
      row.robotNo = this.getRobotNoByEnvironment(code, row.robotNo);
      row.customDomain = code === 'CUSTOM' ? row.customDomain : '';
    },
    applyEnvironmentToAll: function applyEnvironmentToAll(code) {
      var _this3 = this;
      this.appRows.forEach(function (row) {
        row.environmentCode = code;
        row.robotNo = _this3.getRobotNoByEnvironment(code, row.robotNo);
        row.customDomain = code === 'CUSTOM' ? _this3.form.customDomain : '';
      });
      if (code !== 'CUSTOM') this.form.customDomain = '';
      this.$nextTick(function () {
        return _this3.$refs.batchForm && _this3.$refs.batchForm.clearValidate('customDomain');
      });
    },
    applyCustomDomainToAll: function applyCustomDomainToAll(value) {
      this.appRows.forEach(function (row) {
        if (row.environmentCode === 'CUSTOM') row.customDomain = value;
      });
    },
    applyTrialRequestedToAll: function applyTrialRequestedToAll(value) {
      this.appRows.forEach(function (row) {
        row.trialRequested = value;
      });
    },
    validateRows: function validateRows() {
      if (!this.selectedRows.length) return '请至少勾选一个小程序';
      var _iterator = _createForOfIteratorHelper(this.selectedRows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          if (!row.branchName) return "".concat(row.appName, " \u672A\u914D\u7F6EGit\u5206\u652F");
          if (!/^__UNI__[0-9A-Za-z]+$/.test(row.uniAppId || '')) return "".concat(row.appName, " \u7684UniAppID\u683C\u5F0F\u4E0D\u6B63\u786E");
          if (!/^[0-9A-Za-z][0-9A-Za-z._-]{0,63}$/.test(row.versionNo || '')) return "".concat(row.appName, " \u7684\u7248\u672C\u53F7\u683C\u5F0F\u4E0D\u6B63\u786E");
          if (row.environmentCode === 'CUSTOM' && !row.customDomain) return "".concat(row.appName, " \u672A\u586B\u5199\u81EA\u5B9A\u4E49\u57DF\u540D");
          if (row.environmentCode === 'CUSTOM' && (row.robotNo < 5 || row.robotNo > 30)) {
            return "".concat(row.appName, " \u7684\u81EA\u5B9A\u4E49\u73AF\u5883CI\u673A\u5668\u4EBA\u5FC5\u987B\u57285-30\u4E4B\u95F4");
          }
          if (row.trialRequested && !row.wechatApiReady) {
            return "".concat(row.appName, " \u5C1A\u672A\u5B8C\u6210\u5FAE\u4FE1\u7B2C\u4E09\u65B9\u5E73\u53F0\u6388\u6743\u6216\u7F3A\u5C11\u4EE3\u7801\u6743\u9650\uFF0C\u65E0\u6CD5\u81EA\u52A8\u66F4\u65B0\u4F53\u9A8C\u7248");
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '';
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.batchForm.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var error, batch, _t2;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (valid) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                error = _this4.validateRows();
                if (!error) {
                  _context4.n = 2;
                  break;
                }
                _this4.$message.warning(error);
                return _context4.a(2);
              case 2:
                _this4.submitting = true;
                _context4.p = 3;
                _context4.n = 4;
                return (0, _miniProgramVersionApi.createBatchUpload)({
                  versionDesc: _this4.form.versionDesc,
                  items: _this4.selectedRows.map(function (row) {
                    return {
                      companyAppId: row.id,
                      branchName: row.branchName,
                      uniAppId: row.uniAppId,
                      environmentCode: row.environmentCode,
                      robotNo: row.robotNo,
                      customDomain: row.environmentCode === 'CUSTOM' ? row.customDomain : '',
                      versionNo: row.versionNo,
                      trialRequested: row.trialRequested
                    };
                  })
                });
              case 4:
                batch = _context4.v;
                _this4.visible = false;
                _this4.$message.success("\u5DF2\u63D0\u4EA4 ".concat(batch.totalCount, " \u4E2A\u5C0F\u7A0B\u5E8F\u4E0A\u4F20\u4EFB\u52A1"));
                _this4.$emit('created', batch);
                _context4.n = 6;
                break;
              case 5:
                _context4.p = 5;
                _t2 = _context4.v;
              case 6:
                _context4.p = 6;
                _this4.submitting = false;
                return _context4.f(6);
              case 7:
                return _context4.a(2);
            }
          }, _callee4, null, [[3, 5, 6, 7]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.appRows = [];
      this.selectedRows = [];
    }
  }
};